module.exports = __webpack_public_path__ + "img/good.503861a7.png";